export function isInTrialPeriod(trialEndsAt?: string | null): boolean {
  if (!trialEndsAt) return false;
  return new Date(trialEndsAt).getTime() > Date.now();
}

export function isTrialExpired(trialEndsAt?: string | null): boolean {
  if (!trialEndsAt) return false;
  return !isInTrialPeriod(trialEndsAt);
}

export function trialDaysRemaining(trialEndsAt?: string | null): number {
  if (!trialEndsAt) return 0;
  const diff = new Date(trialEndsAt).getTime() - Date.now();
  return Math.max(0, Math.ceil(diff / 86400000));
}

